
import React from 'react';
import { useLanguage } from "@/hooks/useLanguage";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LeakListItem } from "./LeakListItem";
import { ShieldAlert } from "lucide-react";
import { LeakItem } from '@/types/dashboard';
import { Link } from 'react-router-dom';

interface LeaksCardProps {
  leaks: LeakItem[];
  isLoading: boolean;
}

export function LeaksCard({ leaks, isLoading }: LeaksCardProps) {
  const { t } = useLanguage();

  return (
    <Card className="border border-border/50 h-full">
      <CardHeader className="pb-2">
        <CardTitle className="text-xl flex items-center">
          <ShieldAlert className="h-5 w-5 mr-2 text-primary" />
          <Link to="/leaks" className="hover:text-primary transition-colors">
            {t('dashboard.recent_leaks')}
          </Link>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex flex-col gap-2">
                <div className="h-5 w-3/4 bg-secondary/50 animate-pulse rounded-md" />
                <div className="h-4 w-1/4 bg-secondary/30 animate-pulse rounded-md" />
              </div>
            ))}
          </div>
        ) : leaks?.length > 0 ? (
          <div className="space-y-4">
            {leaks.map((leak: LeakItem, index: number) => (
              <LeakListItem key={index} leak={leak} index={index} />
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground text-sm">{t('common.no_results')}</p>
        )}
      </CardContent>
    </Card>
  );
}
